import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { slideToggle } from "./../../composables/slideToggle.js";
import { useAuth } from "../../contexts/AuthContext.jsx";
import ConfirmationDlg from "../../components/ConfirmationDlg";
import LoadingIndicator from "../LoadingIndicator";
import { auth, notification, company, user } from "../../api";
import ModalAnnauncement from "../ModalRelocateSensor/announce";
import ModalRelocateSensor from "../ModalRelocateSensor";
import { toast } from "react-toastify";
import {
  getLastPopupAlert,
  setLastPopupAlert,
} from "../../utils/browserStorage.js";
import {
  getIsDocumentHidden,
  formatDateFull,
  formatDateOnly,
} from "../../utils/helper";
import GinaCore from "../GINA";
import Dropdown from "react-bootstrap/Dropdown";
import { useDashboardContext } from "../../contexts/NewDashboardContext.jsx";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import Swal from "sweetalert2";
import "@sweetalert2/theme-dark/dark.css";
import { MachineHealthNotification } from "../NotificationItem/MachineHealthNotification.jsx";
import { AlertNotification } from "../NotificationItem/AlertNotification.jsx";
import { AssignmentNotification } from "../NotificationItem/AssignmentNotification.jsx";
import { InventoryNotification } from "../NotificationItem/InventoryNotification.jsx";

import { WorkOrderDueDateNotification } from "../NotificationItem/WorkOrderDueDateNotification.jsx";
import { RequestNotification } from "../NotificationItem/RequestNotification.jsx";
import { RequestStatusNotification } from "../NotificationItem/RequestStatusNotification.jsx";
import { HighVibrationAlert } from "../NotificationItem/HighVibrationAlert.jsx";
import { OfflineAlert } from "../NotificationItem/OfflineAlert.jsx";
import { HighTemperatureAlert } from "../NotificationItem/HighTemperatureAlert.jsx";
import { PermissionChecker } from "../PermissionChecker/index.jsx";
function Header() {
  const { config } = useAuth();
  const navigate = useNavigate();
  const currentHost = window.location.host; // Get current domain
  const { selectedApp, handleChangeApp, relocateModal, updateRelocateModal } =
    useDashboardContext();

  const [modalAnnounce, setModalAnnounce] = useState(false);
  const [modalRelocate, setModalRelocate] = useState(false);
  useEffect(() => {
    if (relocateModal) {
      setModalRelocate(true);
    } else {
      setModalRelocate(false);
    }
  }, [relocateModal]);
  const handleNavigation = () => {
    navigate(-1);
    // const previousUrl = window.history.location;
    // // const previousUrl = document.referrer; // Get the referrer URL
    // console.log({ previousUrl, currentHost });
    //
    // // Check if previousUrl is from the same domain and it's not the login page
    // if (previousUrl.includes(currentHost) && !previousUrl.includes("/login")) {
    //   navigate(-1); // Navigate to the previous page
    // } else {
    //   // Perform another action or stay on the current page
    //   console.log("Cannot navigate to the previous page");
    // }
  };
  const [modalPopup, setModalPopup] = useState(false);
  const [modalPopupData, setModalPopupData] = useState([]);
  const [listNotification, setListNotification] = React.useState([]);
  const [badgeCount, setBadgeCount] = useState(0);
  const [loading, setLoading] = React.useState(false);
  const [loadingAll, setLoadingAll] = React.useState(false);
  const [oldPassword, setOldPassword] = React.useState("");
  const [newPassword, setNewPassword] = React.useState("");
  const [confirmPassword, setConfirmPassword] = React.useState("");
  const [open, setOpen] = React.useState(false);
  const [trialModal, setTrialModal] = React.useState(false);
  const [openCGMConfirm, setOpenCGMConfirm] = React.useState(false);
  const [sandBoxConfirm, setSandBoxConfirm] = React.useState(false);
  const [tmpApp, setTmpApp] = useState("");
  const [services, setServices] = useState([]);
  const [activeService, setActiveService] = useState(null);
  const { username, logout, authUser } = useAuth();
  const [confirmDemo, setConfirmDemo] = React.useState(false);
  const [confirmTrial, setConfirmTrial] = React.useState(false);
  const [openConfirmExtend, setOpenConfirmExtend] = React.useState(false);
  const [openCancelExtend, setOpenCancelExtend] = React.useState(false);
  const [qtyExtend, setQtyExtend] = React.useState(1);
  const [cancelReason, setCancelReason] = React.useState("");
  const [page, setPage] = React.useState(1);
  const [totalPage, setTotalPage] = React.useState(1);

  const logoutCall = async () => {
    logout();
    setTimeout(() => {
      window.location.href = "/login";
    }, 500);
  };
  const notificationData = [
    {
      icon: "bi bi-bag text-theme",
      title: "-",
      time: "JUST NOW",
    },
  ];

  async function getNotif() {
    try {
      const result = await notification.listNew(selectedApp);
      if (result.ok) {
        const body = await result.json();
        setBadgeCount(body.data);
      }
    } catch (err) {
      //console.log(err);
    }
  }

  const getNotifications = async (page) => {
    const result = await notification.list(selectedApp, page);

    try {
      if (result.ok) {
        const data = await result.json();
        const newNotifications = data.data.results;
        if (page == 1) {
          setListNotification(newNotifications);
        } else {
          setListNotification((prev) => [...prev, ...newNotifications]);
        }
        setTotalPage(data.data.totalPage);
        setPage(page);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    const getService = async () => {
      const res = await company.getService();
      if (res.ok) {
        const body = await res.json();
        setServices(body.data);
        const tmp = body.data.find((item) => item.service_id === selectedApp);
        console.log({ tmp, service: body.data, selectedApp });
        if (tmp) {
          setActiveService(tmp);
        } else {
          setActiveService(null);
        }
      }
    };

   

    if (username) {
      getService();
    }
  }, [username]);
  useEffect(() => {
    if (config && selectedApp === "CGM") {
      // announcment will trigger once every week
      const getAnnouncement = async () => {
        if (config.is_matar) {
          return;
        }
        const localStorageAnnouncement = localStorage.getItem("announcement");
        if (!localStorageAnnouncement) {
          setModalAnnounce(true);
          const date = new Date();
          localStorage.setItem("announcement", date);
        } else {
          // check if localStorageAnnouncement is date or not,
          // if not then set it to current date
          if (isNaN(Date.parse(localStorageAnnouncement))) {
            setModalAnnounce(true);
            localStorage.setItem("announcement", new Date());
            return;
          }
          const date = new Date(localStorageAnnouncement);
          const now = new Date();
          const diff = now - date;
          const diffDays = diff / (1000 * 60 * 60 * 24);
          if (diffDays > 7) {
            setModalAnnounce(true);
            localStorage.setItem("announcement", now);
          }
        }
      };
      getAnnouncement();
    }
  }, [config, selectedApp]);
  useEffect(() => {
    if (services.length) {
      const tmp = services.find((item) => item.service_id === selectedApp);
      if (tmp) {
        setActiveService(tmp);
      } else {
        setActiveService(null);
      }
    } else {
      setActiveService(null);
    }
  }, [selectedApp]);
  const getPoppedAlert = async () => {
    const lastPopupAlert = getLastPopupAlert();
    let showPopup = false;
    if (lastPopupAlert) {
      // if last Popup ALert is more than 48 hours ago that show popup
      const lastPopupAlertDate = new Date(lastPopupAlert);
      const now = new Date();
      const diff = now - lastPopupAlertDate;
      const diffHours = diff / (1000 * 60 * 60);
      if (diffHours > 48) {
        showPopup = true;
      }
    } else {
      showPopup = true;
    }
    if (showPopup) {
      const result = await notification.list(selectedApp);
      if (result.ok) {
        const data = await result.json();
        const reminder = data.data.filter(
          (item) => item.notif_type === "Reminder"
        );
        if (reminder.length > 0) {
          setModalPopupData(reminder);
          setModalPopup(true);
          setLastPopupAlert(new Date());
        }
      }
    }
  };
  const onSubmit = async () => {
    company.sendRequestTrial();
    Swal.fire({
      title: "Request Submitted!",
      text: "Our team will contact you soon. Thank you!",
      icon: "success",
    });

    setTrialModal(false);
  };
  const onSubmitCancelCGM = async () => {
    company.cancelExtend({ reason: cancelReason });
    Swal.fire({
      title: "Thank you!",
      text: "Thank you for giving us feedback!",
      icon: "success",
    });

    setOpenCancelExtend(false);
  };
  const onSubmitExtendCGM = async () => {
    company.prosesExtentRequest({ machine_qty: qtyExtend });
    Swal.fire({
      title: "Request Submitted!",
      text: "Our team will contact you soon. Thank you!",
      icon: "success",
    });

    setOpenConfirmExtend(false);
  };
  useEffect(() => {
    // setModalAnnounce(true);
    if (username && selectedApp) {
      getPoppedAlert();
      getNotif();
    }
    const interval = setInterval(() => {
      let windowActive = getIsDocumentHidden();
      if (windowActive) {
        if (username && selectedApp) getNotif();
      }
    }, 50000);

    return () => clearInterval(interval);
  }, [selectedApp]);

  const remainingDays = (date) => {
    const currentDate = new Date();
    const endDate = new Date(date);
    const diffTime = endDate - currentDate;
    if (diffTime < 0) return 0;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
  };

  const handleClick = async (item) => {
    if (item.notif_type == "Machine") {
      navigate("/machine/" + item.reference_id);
    }
    if (item.notif_type == "Alert") {
      navigate("/alarm/detail/" + item.reference_id);
    }
    if (item.notif_type == "Reminder") {
      navigate("/alarm/detail/" + item.reference_id);
    }

    if (item.notif_type == "assignment") {
      navigate("/work-order/detail/" + item.reference_id);
    }
    if (item.notif_type == "wo_due_date") {
      navigate("/work-order/detail/" + item.reference_id);
    }
    if (item.notif_type == "inventory") {
      navigate("/part/edit/" + item.reference_id);
    }

    if (item.notif_type == "request") {
      navigate("/request/detail/" + item.reference_id);
    }

    if (item.notif_type == "request_status") {
      navigate("/request/detail/" + item.reference_id);
    }
  };

  const toggleAppSidebarDesktop = () => {
    var elm = document.querySelector(".app");
    if (elm) {
      if (
        !(
          elm.classList.contains("app-with-top-nav") &&
          elm.classList.contains("app-without-sidebar")
        )
      ) {
        elm.classList.toggle("app-sidebar-collapsed");
      }
    }
  };

  const toggleAppSidebarMobile = () => {
    var elm = document.querySelector(".app");
    if (elm) {
      if (
        !(
          elm.classList.contains("app-with-top-nav") &&
          elm.classList.contains("app-without-sidebar")
        )
      ) {
        elm.classList.toggle("app-sidebar-mobile-toggled");
      } else {
        slideToggle(document.querySelector(".app-top-nav"));
      }
    }
  };

  const toggleAppHeaderSearch = () => {
    var elm = document.querySelector(".app");
    elm.classList.toggle("app-header-menu-search-toggled");
  };
  const handleChange = async () => {
    try {
      setLoading(true);
      let result = await auth.changePassword(
        oldPassword,
        confirmPassword,
        newPassword
      );

      if (result.ok) {
        setLoading(false);
        setOpen(false);
        toast.success("Password Successfully Changed");
      } else {
        setLoading(false);
        let oke = await result.json();
        //console.log({ oke });
        let ms1 = Object.keys(oke)[0];
        let message = oke.message;
        toast.error(message);
      }
    } catch (e) {
      //console.log(e.message);
      setLoading(false);
      toast.error(e.message);
      console.error(e);
    }
  };

  const getStatus = (status) => {
    switch (status) {
      case "Acceptable":
        return "status-accept";
      case "Observe":
        return "status-observe";
      case "Alert":
        return "status-alert";
      case "Critical":
        return "status-critical";
      default:
        return "status-pending";
    }
  };

  const getServiceStatus = async () => {
    setLoadingAll(true);
    const res = await company.getService();
    setLoadingAll(false);
    if (res.ok) {
      const body = await res.json();
      setServices(body.data);
      const tmp = body.data.find((item) => item.service_id === tmpApp);
      if (tmp) {
        setActiveService(tmp);
      } else {
        setActiveService(null);
      }
    }
  };

  const handleChangeAppType = async (app) => {
    setTmpApp(app);
    setLoadingAll(true);
    const res = await company.getService();
    setLoadingAll(false);
    if (res.ok) {
      const body = await res.json();
      const cmms = body.data.filter((item) => item.service?.service === "CMMS");
      const cgm = body.data.filter((item) => item.service?.service === "CGM");
      if (app === "CMMS") {
        if (cmms.length === 0) {
          setConfirmTrial(true);
        } else {
          handleChangeApp(app);
          navigate("/work-order/list");
        }
      }
      if (app === "CGM") {
        if (cgm.length === 0) {
          setConfirmDemo(true);
        } else {
          handleChangeApp(app);
          navigate("/machine-health");
        }
      }
      setServices(body.data);
    }
  };
  const tooltip = (word) => (
    <Tooltip id="tooltip">
      <strong>{word}</strong>
    </Tooltip>
  );

  const handleTryTrialAccount = async () => {
    setLoadingAll(true);
    await company.startTrial(tmpApp);
    setLoadingAll(false);
    handleChangeApp(tmpApp);
    getServiceStatus();
    setConfirmDemo(false);
    setConfirmTrial(false);

    if (tmpApp === "CMMS") {
      navigate("/work-order/list");
    }
    if (tmpApp === "CGM") {
      navigate("/machine-health");
    }
  };

  const submitSandbox = async () => {
    setLoadingAll(true);
    console.log({ activeService });
    const action = activeService?.sandbox_active ? "production" : "sandbox";
    const res = await company.switchSandbox(activeService?.id, action);
    setLoadingAll(false);
    if (res.ok) {
      const body = await res.json();
      console.log({ body });
      if (body.success) {
        setSandBoxConfirm(false);
        window.location.reload();
      } else {
        toast.error(body.message);
      }
    } else {
      toast.error("Failed to switch sandbox");
    }
  };

  const closeConfirmSandbox = () => {
    setSandBoxConfirm(false);
  };

  const checkSandbox = () => {
    if (activeService?.service_id === "CMMS") {
      return activeService?.sandbox_active;
    }
  };

  const checkSubscription = () => {
    if (config?.is_matar) return false;
    if (activeService?.service_id === "CGM") {
      // check if subscription_end is less than 7 days
      const remaining = remainingDays(activeService.subscription_end);
      if (remaining <= 7) {
        return `Subscription Ends in ${remaining} days, [${formatDateOnly(
          activeService.subscription_end
        )}]`;
      }
      // if reamaining more than 7 put in week number how many week left
      const week = Math.ceil(remaining / 7);
      return `Subscription Ends in ${week} week(s), [${formatDateOnly(
        activeService.subscription_end
      )}]`;
    }
    return false;
  };

  return (
    <div id="header" className="app-header">
      <LoadingIndicator open={loadingAll} />
      <ModalAnnauncement
        openModal={modalAnnounce}
        setOpenModal={setModalAnnounce}
        onSuccess={() => {
          setModalAnnounce(false);
        }}
        onCancel={() => {
          setModalAnnounce(false);
        }}
      ></ModalAnnauncement>
      <ModalRelocateSensor
        openModal={modalRelocate}
        setOpenModal={setModalRelocate}
        onCancel={() => {
          updateRelocateModal(false);
          setModalRelocate(false);
        }}
      ></ModalRelocateSensor>
      <ConfirmationDlg
        open={trialModal}
        setOpen={setTrialModal}
        onClose={() => setTrialModal(false)}
        title="Subscription Detail"
        onSubmit={() => setTrialModal(false)}
        hideCancelBtn={true}
        btnSubmitText={"Close"}
      >
        <div style={{ position: "relative" }}>
          <div className="alert alert-primary">
            <div className="d-flex">
              <div style={{ paddingRight: "10px" }}>
                <i
                  style={{ fontSize: "30px" }}
                  className="bi bi-exclamation-triangle-fill"
                ></i>
              </div>
              <div>
                Your company does not subscribe to this app!
                <div>Do you want to upgrade your account?</div>
              </div>
            </div>
          </div>
          <button className="btn btn-primary me-2" onClick={onSubmit}>
            Request Upgrade Account
          </button>
        </div>
      </ConfirmationDlg>
      <ConfirmationDlg
        open={openCGMConfirm}
        setOpen={setOpenCGMConfirm}
        onClose={() => setOpenCGMConfirm(false)}
        title="Subscription Detail"
        onSubmit={() => setOpenCGMConfirm(false)}
        hideCancelBtn={true}
        btnSubmitText={"Close"}
      >
        <div style={{ position: "relative" }}>
          <div className="alert alert-primary">
            <div className="d-flex">
              <div style={{ paddingRight: "10px" }}>
                <i
                  style={{ fontSize: "20px" }}
                  className="bi bi-exclamation-triangle-fill"
                ></i>
              </div>
              <div>Your {checkSubscription()}</div>
            </div>
          </div>
          <button
            className="btn btn-primary me-2"
            onClick={() => {
              setOpenConfirmExtend(true);
              setOpenCGMConfirm(false);
            }}
          >
            Extend Subscription
          </button>
          <button
            className="btn btn-warning me-2"
            onClick={() => {
              setOpenCancelExtend(true);
              setOpenCGMConfirm(false);
            }}
          >
            Cancel Extend Subscription
          </button>
        </div>
      </ConfirmationDlg>
      <ConfirmationDlg
        open={openConfirmExtend}
        setOpen={setOpenConfirmExtend}
        onClose={() => setOpenConfirmExtend(false)}
        title="Extend Confirmation"
        onSubmit={() => setOpenConfirmExtend(false)}
        hideCancelBtn={true}
        btnSubmitText={"Close"}
      >
        <div style={{ position: "relative" }}>
          <div>How many machine do you want to extend?</div>
          <div style={{ marginBottom: "10px" }}>
            <input
              value={qtyExtend}
              onChange={(e) => setQtyExtend(e.target.value)}
              type="number"
              className="form-control border-theme"
            />
          </div>
          <button className="btn btn-primary me-2" onClick={onSubmitExtendCGM}>
            Request Extend
          </button>
        </div>
      </ConfirmationDlg>
      <ConfirmationDlg
        open={openCancelExtend}
        setOpen={setOpenCancelExtend}
        onClose={() => setOpenCancelExtend(false)}
        title="Cancel Confirmation"
        onSubmit={() => setOpenCancelExtend(false)}
        hideCancelBtn={true}
        btnSubmitText={"Close"}
      >
        <div style={{ position: "relative" }}>
          <div>Why you want to cancel extend subscription?</div>
          <div style={{ marginBottom: "10px" }}>
            <input
              type="text"
              value={cancelReason}
              onChange={(e) => setCancelReason(e.target.value)}
              className="form-control border-theme"
            />
          </div>
          <button className="btn btn-primary me-2" onClick={onSubmitCancelCGM}>
            Cancel Extend
          </button>
        </div>
      </ConfirmationDlg>
      <ConfirmationDlg
        open={confirmDemo}
        setOpen={setConfirmDemo}
        onClose={() => setConfirmDemo(false)}
        title="Groundup Switching App Confirmation"
        onSubmit={handleTryTrialAccount}
        btnSubmitText={"Try Demo"}
        btnCancelText={"Cancel"}
      >
        <div style={{ position: "relative" }}>
          <div className="alert alert-primary">
            <div className="d-flex">
              <div style={{ paddingRight: "10px" }}>
                <i
                  style={{ fontSize: "30px" }}
                  className="bi bi-exclamation-triangle-fill"
                ></i>
              </div>
              <div>
                Your company does not subscribe to this app!
                <div>Do you want to try Demo of this app?</div>
              </div>
            </div>
          </div>
        </div>
      </ConfirmationDlg>
      <ConfirmationDlg
        open={confirmTrial}
        setOpen={setConfirmTrial}
        onClose={() => setConfirmTrial(false)}
        title="Groundup Switching App Confirmation"
        onSubmit={handleTryTrialAccount}
        btnSubmitText={"Try Trial Account"}
        btnCancelText={"Cancel"}
      >
        <div style={{ position: "relative" }}>
          <div className="alert alert-primary">
            <div className="d-flex">
              <div style={{ paddingRight: "10px" }}>
                <i
                  style={{ fontSize: "30px" }}
                  className="bi bi-exclamation-triangle-fill"
                ></i>
              </div>
              <div>
                Your company does not subscribe to this app!
                <div>Do you want to try trial account for this app?</div>
              </div>
            </div>
          </div>
        </div>
      </ConfirmationDlg>
      <ConfirmationDlg
        open={open}
        setOpen={setOpen}
        onClose={() => setOpen(false)}
        title="Change Password"
        onSubmit={handleChange}
        btnSubmitText={"Change Password"}
        btnCancelText={"Cancel"}
      >
        <div style={{ position: "relative" }}>
          <LoadingIndicator open={loading} />
          <div className="mb-3">
            <label className="form-label">
              Old Password <span className="text-danger">*</span>
            </label>
            <input
              type="password"
              required={true}
              value={oldPassword}
              onChange={(e) => setOldPassword(e.target.value)}
              className="form-control form-control-lg bg-white bg-opacity-5"
              placeholder=""
            />
          </div>
          <div className="mb-3">
            <label className="form-label">
              New Password <span className="text-danger">*</span>
            </label>
            <input
              type="password"
              required={true}
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              className="form-control form-control-lg bg-white bg-opacity-5"
              placeholder=""
            />
          </div>
          <div className="mb-3">
            <label className="form-label">
              Confirm New Password<span className="text-danger">*</span>
            </label>
            <input
              type="password"
              required={true}
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              className="form-control form-control-lg bg-white bg-opacity-5"
              placeholder=""
            />
          </div>
        </div>
      </ConfirmationDlg>
      <ConfirmationDlg
        btnSubmitText={"Yes, take me in!"}
        open={sandBoxConfirm}
        onClose={closeConfirmSandbox}
        onSubmit={submitSandbox}
        title="Switch to Sandbox"
      >
        <div style={{ position: "relative" }}>
          <div className="alert alert-primary">
            <div className="d-flex">
              <div style={{ paddingRight: "10px" }}>
                <i
                  style={{ fontSize: "30px" }}
                  className="bi bi-exclamation-triangle-fill"
                ></i>
              </div>
              <div>
                Currently you are running using your{" "}
                {activeService?.sandbox_active ? "Sandbox" : "production"} Data!
                {activeService?.sandbox_active ? (
                  <>Do you want to switch to production data?</>
                ) : (
                  <>
                    <div>Do you want to try Sandbox/demo version?</div>
                    We will fill all the data with demo data, and you can play
                    with it.
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </ConfirmationDlg>
      <div className="desktop-toggler">
        <button
          type="button"
          className="menu-toggler"
          onClick={toggleAppSidebarDesktop}
        >
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </button>
      </div>

      <div className="mobile-toggler">
        <button
          type="button"
          className="menu-toggler"
          onClick={toggleAppSidebarMobile}
        >
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </button>
      </div>

      <div className="brand">
        {config?.is_matar ? null : (
          <Dropdown>
            <Dropdown.Toggle
              id="dropdown-basic"
              style={{ background: "none", border: "none" }}
            >
              {selectedApp === "CGM" ? (
                <span>
                  <i className="bi bi-wrench-adjustable-circle"></i> CGM App
                </span>
              ) : (
                <span>
                  <i className="bi bi-person-fill-gear"></i> CMMS App
                </span>
              )}
            </Dropdown.Toggle>
            {/* 
            <Dropdown.Menu>
              <Dropdown.Item
                disabled={true}
                onClick={() => handleChangeAppType("CGM")}
              >
                <i className="bi bi-wrench-adjustable-circle"></i> CGM App
              </Dropdown.Item>
              <Dropdown.Item onClick={() => handleChangeAppType("CMMS")}>
                <i className="bi bi-person-fill-gear"></i> CMMS App
              </Dropdown.Item>
              <Dropdown.Item
                disabled={true}
                onClick={() => handleChangeAppType("Groundup Academy")}
              >
                <i className="bi bi-person-badge"></i> Groundup Academy
              </Dropdown.Item>
            </Dropdown.Menu> */}
          </Dropdown>
        )}

        <div
          className="btn btn-outline-theme back-nav"
          style={{
            marginLeft: "24px",
            width: "66px",
            fontSize: "11px",
            padding: "2px",
          }}
          onClick={handleNavigation}
        >
          <i className="fa fa-arrow-left"></i> Back
        </div>
      </div>
      {selectedApp === "CMMS" ? (
        <div
          className="menu-item dropdown subscription-item"
          style={{
            marginTop: "13px",
          }}
          onClick={() => {
            setSandBoxConfirm(true);
          }}
        >
          <OverlayTrigger
            placement="bottom"
            overlay={tooltip("Click to Switch to Sandbox.")}
          >
            <div
              className={
                "alert alert-light cursor-pointer subscription-text border border-1 border-theme text-theme"
              }
              style={{ padding: "3px", margin: 0, cursor: "pointer" }}
            >
              {activeService?.sandbox_active ? (
                <>
                  <i className="fa fa-flask"></i> Sandbox
                </>
              ) : (
                <>
                  <i className="fa fa-rocket"></i> Production
                </>
              )}
            </div>
          </OverlayTrigger>
        </div>
      ) : null}

      <div className="menu">
        <div className="menu-item logo-item" style={{ flex: "1" }}>
          <img
            style={{ margin: "auto" }}
            src="/assets/img/logo_white.svg"
            alt=""
            className="header-logo"
          />
        </div>
        {activeService?.status?.toLowerCase() === "trial" ? (
          <div
            className="menu-item dropdown subscription-item"
            onClick={() => {
              setTrialModal(true);
            }}
          >
            <OverlayTrigger
              placement="bottom"
              overlay={tooltip("Click to view Detail.")}
            >
              <div
                className={"alert alert-light cursor-pointer subscription-text"}
                style={{ padding: "3px", margin: 0, cursor: "pointer" }}
              >
                Your Trial End in{" "}
                <b>{remainingDays(activeService.subscription_end)} Days</b>
              </div>
            </OverlayTrigger>
          </div>
        ) : null}
        {checkSubscription() ? (
          <div
            className="menu-item dropdown subscription-item"
            onClick={() => {
              setOpenCGMConfirm(true);
            }}
          >
            <OverlayTrigger
              placement="bottom"
              overlay={tooltip("Click to view Detail.")}
            >
              <div
                className={"alert alert-light cursor-pointer subscription-text"}
                style={{ padding: "3px", margin: 0, cursor: "pointer" }}
              >
                {checkSubscription()}
              </div>
            </OverlayTrigger>
          </div>
        ) : null}

        <div className="menu-item dropdown dropdown-mobile-full">
          <a
            href="#/"
            data-bs-toggle="dropdown"
            data-bs-display="static"
            className="menu-link"
            onClick={() => getNotifications(1)}
          >
            <div className="menu-icon">
              <i className="bi bi-bell nav-icon"></i>
            </div>
            {badgeCount ? <div className="menu-badge bg-theme"></div> : null}
          </a>
          <div className="dropdown-menu dropdown-menu-end mt-1 w-300px fs-11px pt-1">
            <h6 className="dropdown-header fs-10px mb-1">
              GINA.AI NOTIFICATION:
            </h6>
            <div className="dropdown-divider mt-1"></div>
            <div
              style={{
                height: "500px",
                overflow: "auto",
              }}
            >
              {listNotification.length > 0 ? (
                <>
                  {listNotification.map((item, index) => (
                    <div
                      key={`notifAlert-${index}`}
                      className="box-alert-left"
                      onClick={() => {
                        handleClick(item);
                      }}
                      style={{
                        background: `rgba(255, 255, 255, 0.14)`,
                        position: "relative",
                        padding: "10px",
                        marginTop: "5px",
                        border: "1px solid #d5d5d5",
                      }}
                    >
                      {item.notif_type == "Machine" && (
                        <MachineHealthNotification item={item} />
                      )}
                      {(item.notif_type == "Alert" ||
                        item.notif_type == "Reminder") && (
                        <AlertNotification item={item} />
                      )}
                      {item.notif_type == "high_vibration_alert" && (
                        <HighVibrationAlert item={item} />
                      )}
                      {item.notif_type == "high_temperature_alert" && (
                        <HighTemperatureAlert item={item} />
                      )}
                      {item.notif_type == "offline_alert" && (
                        <OfflineAlert item={item} />
                      )}

                      {/* CMMS */}
                      {item.notif_type == "assignment" && (
                        <AssignmentNotification item={item} />
                      )}
                      {item.notif_type == "request" && (
                        <RequestNotification item={item} />
                      )}

                      {item.notif_type == "request_status" && (
                        <RequestStatusNotification item={item} />
                      )}
                      {item.notif_type == "inventory" && (
                        <InventoryNotification item={item} />
                      )}
                      {item.notif_type == "wo_due_date" && (
                        <WorkOrderDueDateNotification item={item} />
                      )}
                    </div>
                  ))}
                  {page < totalPage && (
                    <div className="text-center mt-2">
                      <button
                        className="btn btn-primary"
                        onClick={(e) => {
                          e.stopPropagation(); // <-- Add this line
                          getNotifications(page + 1);
                        }}
                      >
                        More Notifications
                      </button>
                    </div>
                  )}
                </>
              ) : (
                <div className="dropdown-notification-item p-3 text-center">
                  Notification is empty
                </div>
              )}
            </div>
            <hr className="mb-0 mt-2" />
          </div>
        </div>
        <div className="menu-item dropdown dropdown-mobile-full tour-profile">
          <a
            href="#/"
            data-bs-toggle="dropdown"
            data-bs-display="static"
            className="menu-link"
          >
            <div className="menu-img online">
              <img
                src="/assets/img/user/profile.jpg"
                alt="Profile"
                height="60"
              />
            </div>
            <div className="menu-text d-sm-block d-none w-170px">
              {authUser?.firstname}
            </div>
          </a>
          <div className="dropdown-menu dropdown-menu-end me-lg-3 fs-11px mt-1">
            <div
              className="dropdown-item d-flex align-items-center"
              style={{ cursor: "pointer" }}
              onClick={() => {
                setOpen(true);
              }}
            >
              <div style={{ marginRight: "10px" }}>CHANGE PASSWORD</div>{" "}
              <i className="bi bi-gear ms-auto text-theme fs-16px my-n1"></i>
            </div>
            <div className="dropdown-divider"></div>
            <Link
              to="#"
              onClick={logoutCall}
              className="dropdown-item d-flex align-items-center"
            >
              LOGOUT{" "}
              <i className="bi bi-toggle-off ms-auto text-theme fs-16px my-n1"></i>
            </Link>
          </div>
        </div>
      </div>

      <form className="menu-search" method="POST" name="header_search_form">
        <div className="menu-search-container">
          <div className="menu-search-icon">
            <i className="bi bi-search"></i>
          </div>
          <div className="menu-search-input">
            <input
              type="text"
              className="form-control form-control-lg"
              placeholder="Search menu..."
            />
          </div>
          <div className="menu-search-icon">
            <a href="#/" onClick={toggleAppHeaderSearch}>
              <i className="bi bi-x-lg"></i>
            </a>
          </div>
        </div>
      </form>
      {config?.is_matar ? null : (
        <PermissionChecker permissions={["view gina ai"]} hideIfNotAllowed>
          {/* <GinaCore /> */}
        </PermissionChecker>
      )}
    </div>
  );
}

export default Header;
